import { CustomLayer } from "../interfaces/custom-layer";
import us_states_geojson from "./geo_jsons/us_states.json";



export const layers: CustomLayer[] = [
    {
        id: "us_states",
        source: { type: "geojson", data: us_states_geojson as any },
        options: {
            id: "us_states",
            source: "us_states",
            type: "line",
            layout: {
                visibility: "visible",
            },
            paint: {
                "line-color": "#000",
                "line-opacity": 0.75
            }
        }
    }
];